import { Modal } from "materia"
import type { ReactNode } from "react"
import { modifiers } from "ui-tools"
import s from "./ChatModal.module.scss"

type ChatModalProps = {
  ariaLabel: string
  onClose: () => void
  /** As tall as its contents, for a short step like naming a group. */
  isCompact?: boolean
  children: ReactNode
}

/**
 * Materia's modal in the size chat uses. Every chat modal goes through this, so
 * they cannot disagree about their width or jump when their contents change.
 */
export function ChatModal({
  ariaLabel,
  onClose,
  isCompact = false,
  children,
}: ChatModalProps) {
  return (
    <Modal
      ariaLabel={ariaLabel}
      onClose={onClose}
      showCloseButton
      isFullScreenMobile
    >
      <div className={modifiers(s, "chatModal", { isCompact })}>{children}</div>
    </Modal>
  )
}
